export async function request<I, O>({
  api,
  method = 'GET',
  body,
  abortController,
}: {
  api: string;
  method: string;
  body?: I;
  abortController?: () => AbortController | null;
}): Promise<O> {
  const response = await fetch(api, {
    method,
    body: body ? JSON.stringify(body) : undefined,
    headers: {
      'Content-Type': 'application/json',
    },
    signal: abortController?.()?.signal,
  });

  if (!response.ok || !response.body) {
    throw new Error(
      (await response.text()) || 'Não foi possível obter uma resposta.'
    );
  }

  return response.json();
}
